/**
 * Translations for the BuildingInteriorPage (the inside of one of the
 * kid's bought-and-built houses).
 */
const building = {
  zh: {
    'building.back': '返回',
    'building.unnamed': '我的房子',
    'building.subtitle': '类型：{type} · 当前已摆 {count} 件',
    'building.save': '保存',
    'building.toast.saved': '布置已保存 ✅',
    'building.empty': '🏠 还没在房子里放任何东西～\n从下方背包里点一件就能放进来',
    'building.tile.remove': '移开「{name}」',
    'building.inventory.title': '我的背包',
    'building.inventory.helper': '点一下添加到房子里。点房子里的物品可以拿走。',
    'building.inventory.empty': '背包里还没有可以放进房子的物品。先去商店买墙纸 / 地板 / 家具 / 玩具吧～',
    'building.inventory.shop': '去商店买东西',
    'building.inventory.add': '把「{name}」放进房子',
    'building.error.load': '加载房子失败',
    'building.error.save': '保存失败',
    'building.error.badId': '房子地址不对',
  } as Record<string, string>,
  en: {
    'building.back': 'Back',
    'building.unnamed': 'My house',
    'building.subtitle': 'Type: {type} · {count} item(s) placed',
    'building.save': 'Save',
    'building.toast.saved': 'Saved ✅',
    'building.empty': "🏠 Nothing inside yet —\ntap an item from your bag below to drop it in",
    'building.tile.remove': 'Take away "{name}"',
    'building.inventory.title': 'My bag',
    'building.inventory.helper': 'Tap to drop into the room. Tap a room item to take it out.',
    'building.inventory.empty': "Nothing in your bag that can be placed indoors. Visit the shop to buy wallpaper / floors / furniture / toys!",
    'building.inventory.shop': 'Go to the shop',
    'building.inventory.add': 'Put "{name}" in the room',
    'building.error.load': 'Failed to load this house',
    'building.error.save': 'Save failed',
    'building.error.badId': 'Bad house address',
  } as Record<string, string>,
};
export default building;
